






































































































































































import { getPopWindowTemplateList, createAbtestPop } from "@/services/api";
import { Message } from "element-ui";
import { Component, Vue, Prop ,Watch } from "vue-property-decorator";


@Component({})
export default class ABTestAddNewDialog extends Vue {
  @Prop()
  visible!:boolean;

  @Prop()
  abTestDetail?:any;

  currentType = 0;
  isType(type:number) {
    return type === this.currentType;
  }

  createList:any[] = [];
  createListIndex = -1;
  createType = 0;
  templateid = 1;
  companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id;

  apiLoading = false;

  @Watch('abTestDetail')
  getAbtestData() {
    if (this.abTestDetail && this.abTestDetail.triggerEventType !== undefined) {
      this.currentType = this.abTestDetail.triggerEventType;
    // if (this.createList.length == 0) {
      console.log('123123123e', this.abTestDetail);
      getPopWindowTemplateList({
        companyId: this.companyId,
        triggerEventType: this.abTestDetail.triggerEventType
      },true).then(({data, status}) => {
        if (status == 200) {
          this.createList = data.data;
          this.createListIndex = 1
          if (this.createList.length > 0) {
            this.createType = this.createList[0].type
            this.templateid = this.createList[0].id
          }
        }
      })
    // }
    }
  }

  get shopType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (companyInfo.integrationType) {
      return companyInfo.integrationType?.toLowerCase();
    }
    return ``;
  }

  createClick(item:any,index:number){
    if(item.isShow){
      this.templateid = item.id
      this.createListIndex = index + 1
      this.createType = item.type
    }
  }

  createToRoute(){
    /**
     * 1. 根据模版获取配置
     * 2. 根据配置生成草稿
     * 3. 草稿加入到abtest
     */
    this.apiLoading = true;
    // 请求完成
    createAbtestPop({
      mainFormId: this.abTestDetail.id,
      formTemplateId: this.templateid,
    }).then((res) => {
      if (this.createList.length > 0) {
        this.createListIndex = 1;
        this.createType = this.createList[0].type
        this.templateid = this.createList[0].id
      } else {
        this.createListIndex = -1;
        this.createType = 0;
        this.templateid = 1;
      }
      this.$emit('changeDetail');
      this.$emit('update:visible', false);
      this.apiLoading = false;
      Message.success(this.$tx('settings.page.addedSuccessfully', '添加成功'));
    }).catch(() => {
      this.apiLoading = false;
    })
  }

  showCombinationTypeTemplate(tempId: any) {
    // 是否显示最新的多折扣码弹窗,不显示
    if (`${tempId}` !== '40' && `${tempId}` !== '41' && `${tempId}` !== '19' && `${tempId}` !== '20') {
      return true;
    }
  }

  handleClose() {
    if (this.createList.length > 0) {
      this.createListIndex = 1;
      this.createType = this.createList[0].type
      this.templateid = this.createList[0].id
    } else {
      this.createListIndex = -1;
      this.createType = 0;
      this.templateid = 1;
    }
    this.$emit('update:visible', false);
    this.apiLoading = false;
  }
}
